"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingGeneratorModal = void 0;
const diem_1 = __importDefault(require("@travelnest/diem"));
const merlin_date_picker_1 = require("@travelnest/merlin.date-picker");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const React = __importStar(require("react"));
const InlineMessage_1 = require("../inline-message/InlineMessage");
const helpers_1 = require("../../../entities/pricing/helpers");
const seasonality_1 = require("../../../entities/pricing/seasonality");
const constants_1 = require("../../constants");
const Modal_1 = require("../modal/Modal");
const Button_1 = require("../button/Button");
const Chip_1 = require("../chip/Chip");
const Label_1 = require("../input/label/Label");
const CurrencyInput_1 = require("../input/currency/CurrencyInput");
const merlin_select_1 = require("@travelnest/merlin.select");
const Paragraph_1 = require("../paragraph/Paragraph");
const PricingEQBar_1 = require("../pricing-eq-bar/PricingEQBar");
const Spacer_1 = require("../spacer/Spacer");
const types_1 = require("../../../types");
const Heading_1 = require("../heading/Heading");
// TODO: Designs for intro page have a placeholder for an image above section header but we don't have an image to put here yet
const IntroPage = () => React.createElement(React.Fragment, null,
    React.createElement(Heading_1.HeadingSmall, null, "Build your perfect pricing model"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "Pricing your property can be difficult, we get it! Using this tool, we will help you to quickly build 24 months of pricing."),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "You'll be able to fine tune it afterwards."));
const StartDatePage = (props) => {
    const [selectedDate, setSelectedDate] = React.useState(props.pricingOptions.startDate);
    const dateChangeHandler = (newDate) => {
        if (newDate !== undefined) {
            setSelectedDate(newDate);
            props.onChangeOption('startDate', newDate);
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Heading_1.HeadingSmall, null, "Override your existing pricing"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "Let's get you new pricing! By following the next few prompts, we will overwrite your existing pricing and generate 2 years worth of new pricing."),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "If instead you simply wish to extend the pricing you already have, adjust the start date below. 2 years of pricing will be generated from that start date."),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(Label_1.Label, { htmlFor: "pricing-start-date" }, "Start date"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(merlin_date_picker_1.DatePicker, { id: "pricing-generator-start-date", minDate: new diem_1.default().toISOString(), value: selectedDate, onChange: dateChangeHandler }));
};
// TODO: When currency input field available, use that with currency passed via props
const PricePerNightPage = (props) => {
    const [pricePerNight, setPricePerNight] = React.useState(props.defaultPrice);
    const currencySymbol = (0, helpers_1.getCurrencySymbol)(props.currency);
    const pricingSuggestion = !!props.pricingSuggestion ?
        `In your local area the average nightly price ranges from ${currencySymbol}${props.pricingSuggestion.low} to ${currencySymbol}${props.pricingSuggestion.high}`
        : '';
    const onPricePerNightChange = (ppn) => {
        if (ppn !== undefined) {
            setPricePerNight(ppn);
            props.onChangeOption('standardPricePerNight', ppn);
        }
    };
    const maxPriceThousands = constants_1.MAX_NIGHTLY_PRICE.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    return React.createElement(React.Fragment, null,
        React.createElement(Heading_1.HeadingSmall, null,
            React.createElement(Label_1.Label, { htmlFor: "standard-price-per-night" }, "Standard price per night")),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "Tell us the average price you would charge for a night in your property. We'll use this as a base for your pricing model."),
        React.createElement(Spacer_1.Spacer, null),
        !!pricingSuggestion && React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'pricing-suggestion', text: pricingSuggestion }),
        React.createElement(Label_1.Label, { htmlFor: "standard-price-per-night" }, "Standard price per night"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(CurrencyInput_1.CurrencyInput, { id: "standard-price-per-night", value: pricePerNight, handleChange: onPricePerNightChange, invalid: !pricePerNight || pricePerNight <= 0 || pricePerNight > constants_1.MAX_NIGHTLY_PRICE, currency: props.currency }),
        (!pricePerNight || pricePerNight <= 0 || pricePerNight > constants_1.MAX_NIGHTLY_PRICE) && React.createElement(React.Fragment, null,
            React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
            React.createElement(InlineMessage_1.InlineError, { text: `Your standard price has to be in range (${currencySymbol}1 to ${currencySymbol}${maxPriceThousands})` })));
};
const SeasonalityPage = (props) => {
    const [selectedSeasonality, setSelectedSeasonality] = React.useState(seasonality_1.SeasonalityTemplate.Gradual);
    const onSelectChange = (e) => {
        const template = e.target.value;
        setSelectedSeasonality(template);
        props.onChangeOption('seasonalityTemplate', template);
    };
    const graphPrices = () => {
        const pricingData = (0, seasonality_1.pricingTemplateData)(selectedSeasonality);
        return Object.keys(pricingData).map((month) => ({
            name: month.slice(0, 1).toUpperCase(),
            percentage: pricingData[month],
        }));
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Heading_1.HeadingSmall, null, "Seasonality"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "To help us create your pricing model, select a seasonality that closest matches your property."),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(merlin_select_1.Select, { label: "Seasonality", id: "seasonality-template", onChange: onSelectChange, value: selectedSeasonality }, Object.keys(seasonality_1.SeasonalityTemplate).map((t) => React.createElement("option", { key: t, value: seasonality_1.SeasonalityTemplate[t] }, seasonality_1.SeasonalityTemplate[t]))),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(PricingEQBar_1.PricingEQBar, { standardPrice: props.pricingOptions.standardPricePerNight, minPrice: 0, maxPrice: 100, currencySymbol: props.currency, averageNightlyPrices: graphPrices(), omitLegend: true }));
};
const MinimumStayPage = (props) => {
    const [minimumStay, setMinimumStay] = React.useState(1);
    const onChangeHandler = (n) => {
        setMinimumStay(n);
        props.onChangeOption('minimumStay', n);
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Heading_1.HeadingSmall, null, "Minimum nights stay"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "What is the shortest duration a guest can stay for?"),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(merlin_input_stepper_1.InputStepper, { id: "minimum-nights-stay", onClick: onChangeHandler, maxValue: 7, value: minimumStay, valueFormatter: (n) => `${n} nights` }),
        React.createElement(Spacer_1.Spacer, null),
        React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'min-stay', text: "A minimum stay of 1 or 2 nights will increase your chances of getting booked" }));
};
const ArrivalDaysPage = (props) => {
    const [arrivalDays, setArrivalDays] = React.useState((0, helpers_1.allDaysAllowed)());
    const setDay = (day, selected) => {
        const _a = arrivalDays, _b = day, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        const newArrivalDays = Object.assign({ [day]: selected }, rest);
        setArrivalDays(newArrivalDays);
        props.onChangeOption('arrivalDays', newArrivalDays);
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Heading_1.HeadingSmall, null, "Arrival days"),
        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
        React.createElement(Paragraph_1.Paragraph, null, "On which days can guests arrive?"),
        React.createElement(Spacer_1.Spacer, null),
        Object.entries(types_1.DaysOfWeekFullNames).map(([dow, fullName]) => (React.createElement(Chip_1.Chip, { id: dow, key: dow, text: fullName, selected: arrivalDays[dow], onChange: (_, selected) => setDay(dow, selected) }))));
};
const OutroPage = () => React.createElement(React.Fragment, null,
    React.createElement(Heading_1.HeadingSmall, null, "Your pricing is ready!"),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "We've built 24 months of pricing based on what you have specified."),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "You'll see it broken down into months."),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "You can now review your pricing and make any changes you require"));
var PricingGeneratorPage;
(function (PricingGeneratorPage) {
    PricingGeneratorPage[PricingGeneratorPage["Intro"] = 0] = "Intro";
    PricingGeneratorPage[PricingGeneratorPage["StartDate"] = 1] = "StartDate";
    PricingGeneratorPage[PricingGeneratorPage["PricePerNight"] = 2] = "PricePerNight";
    PricingGeneratorPage[PricingGeneratorPage["Seasonality"] = 3] = "Seasonality";
    PricingGeneratorPage[PricingGeneratorPage["MinimumStay"] = 4] = "MinimumStay";
    PricingGeneratorPage[PricingGeneratorPage["ArrivalDays"] = 5] = "ArrivalDays";
    PricingGeneratorPage[PricingGeneratorPage["Outro"] = 6] = "Outro";
})(PricingGeneratorPage || (PricingGeneratorPage = {}));
;
const modalPages = {
    [PricingGeneratorPage.Intro]: IntroPage,
    [PricingGeneratorPage.StartDate]: StartDatePage,
    [PricingGeneratorPage.PricePerNight]: PricePerNightPage,
    [PricingGeneratorPage.Seasonality]: SeasonalityPage,
    [PricingGeneratorPage.MinimumStay]: MinimumStayPage,
    [PricingGeneratorPage.ArrivalDays]: ArrivalDaysPage,
    [PricingGeneratorPage.Outro]: OutroPage,
};
const buildModalButtons = (page, next, prev, onClose, generatePricing, invalidInput) => {
    const previousButton = React.createElement(Button_1.Button, { onClick: prev }, "Previous");
    const nextButton = React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next, disabled: invalidInput }, "Next");
    if (page === PricingGeneratorPage.Intro) {
        return { actionLHS: React.createElement("span", null), actionRHS: React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next }, "Get started") };
    }
    else if (page === PricingGeneratorPage.ArrivalDays) {
        const nextAndGenerate = () => {
            generatePricing();
            next();
        };
        return {
            actionLHS: previousButton,
            actionRHS: React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: nextAndGenerate }, "Generate pricing")
        };
    }
    else if (page === PricingGeneratorPage.Outro) {
        return { actionLHS: React.createElement("span", null), actionRHS: React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: onClose }, "View pricing") };
    }
    else {
        return { actionLHS: previousButton, actionRHS: nextButton };
    }
};
const PricingGeneratorModal = (props) => {
    const { onClose, onChangeOption, generatePricing, pricingOptions, hasExistingPricing, currency, defaultPrice, pricingSuggestion } = props;
    const [currentPage, setCurrentPage] = React.useState(PricingGeneratorPage.Intro);
    const onNextPageTap = () => {
        if (currentPage !== PricingGeneratorPage.Outro) {
            let nextPage = currentPage + 1;
            if (nextPage === PricingGeneratorPage.StartDate && !hasExistingPricing) {
                nextPage++;
            }
            setCurrentPage(nextPage);
        }
    };
    const onPreviousPageTap = () => {
        if (currentPage !== PricingGeneratorPage.Intro) {
            setCurrentPage(currentPage - 1);
        }
    };
    // tslint:disable-next-line:max-line-length
    const invalidDefaultPrice = ((currentPage === 2 && !pricingOptions.standardPricePerNight) || (pricingOptions.standardPricePerNight !== undefined && (pricingOptions.standardPricePerNight <= 0 || pricingOptions.standardPricePerNight > constants_1.MAX_NIGHTLY_PRICE)));
    const buttons = buildModalButtons(currentPage, onNextPageTap, onPreviousPageTap, onClose, generatePricing, invalidDefaultPrice);
    return React.createElement(Modal_1.Modal, Object.assign({ title: "Add pricing", onRequestClose: onClose }, buttons), React.createElement(modalPages[currentPage], { currency, defaultPrice, pricingOptions, onChangeOption, pricingSuggestion }));
};
exports.PricingGeneratorModal = PricingGeneratorModal;
//# sourceMappingURL=PricingGeneratorModal.js.map